import { Controller } from "stimulus"

// Burger + menu deplie (mobile / tablette).
// Syntaxe historique `data-target="navbar.xxx"` (Stimulus 2) ; la syntaxe
// `data-navbar-target` est posee en parallele pour une migration future.
export default class extends Controller {
  static targets = ["content", "burger"]

  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this)

    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onDocumentKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onDocumentKeydown)
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
    }

    this.setOpen(!this.isOpen())
  }

  // Le burger est un <a role="button"> : Entree et Espace doivent l'activer.
  keydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      this.toggle(event)
    }
  }

  close() {
    this.setOpen(false)
  }

  isOpen() {
    return this.hasContentTarget && this.contentTarget.classList.contains("is-active")
  }

  setOpen(open) {
    if (!this.hasContentTarget) {
      return
    }

    this.contentTarget.classList.toggle("is-active", open)

    if (this.hasBurgerTarget) {
      this.burgerTarget.classList.toggle("is-active", open)
      this.burgerTarget.setAttribute("aria-expanded", open ? "true" : "false")
      this.burgerTarget.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu")
    }
  }

  onDocumentClick(event) {
    if (!this.isOpen()) {
      return
    }

    // Le burger peut etre hors du conteneur (topbar vs sidebar) : son propre
    // clic gere l'ouverture, on ne le traite pas comme un clic exterieur.
    if (this.hasBurgerTarget && this.burgerTarget.contains(event.target)) {
      return
    }

    const container = this.contentTarget.closest("nav, aside")

    if (container && !container.contains(event.target)) {
      this.close()
    }
  }

  onDocumentKeydown(event) {
    if (event.key === "Escape" && this.isOpen()) {
      this.close()

      if (this.hasBurgerTarget) {
        this.burgerTarget.focus()
      }
    }
  }
}
